import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import { Card, Col, Collapse, Row } from "react-bootstrap";
import { GET_ME, GET_ORGANIZATIONS, GET_USERS } from "../../../graphql/queries";
import {
    MeData,
    Organization,
    OrganizationData,
    User,
    UsersData
} from "../../../models/types";
import { UsersPerOrganization } from "../../lists/admin/UsersPerOrganization";
import { InviteTools } from "./InviteTools";

export const UserTools = () => {
    const [showUsers, updateShowUsers] = useState(false);
    const { data: { me } = {} } = useQuery<MeData>(GET_ME, {
        fetchPolicy: "cache-first"
    });
    const { data: { organizations } = {} } =
        useQuery<OrganizationData>(GET_ORGANIZATIONS);
    const { data: { users } = {} } = useQuery<UsersData>(GET_USERS, {
        variables: {
            organizationId: me?.organization?.id
        }
    });

    if (!users) {
        return <p className="text-contrast">No users found</p>;
    }

    const getUsersByOrg = (orgId: number | undefined) => {
        return users.filter((user: User) => user.organization?.id === orgId);
    };
    const alternatives = organizations?.map(
        (organization: Organization, index: number) => (
            <Col key={index} className="col-12">
                <UsersPerOrganization
                    organizationName={organization.name}
                    organizationId={organization.id}
                    users={getUsersByOrg(organization.id)}
                />
            </Col>
        )
    );

    return (
        <Card className="mt-3">
            <Card.Header onClick={() => updateShowUsers(!showUsers)}>
                <h5 className="text-muted mouseHover">User Tools</h5>
            </Card.Header>

            <Collapse in={showUsers}>
                <div>
                    <Card.Body>
                        <Row className="d-flex justify-content-center align-items-end">
                            <Col className="col-12">{alternatives}</Col>
                        </Row>
                        <Row className="d-flex justify-content-center align-items-end">
                            <Col className="col-12">
                                <UsersPerOrganization
                                    key="users-without-org"
                                    organizationName="Users without organization"
                                    organizationId={undefined}
                                    users={getUsersByOrg(undefined)}
                                />
                            </Col>
                        </Row>
                        <InviteTools />
                    </Card.Body>
                </div>
            </Collapse>
        </Card>
    );
};
